import Component from "./UniCell";
import Bottom from "./components/Bottom/UniCellBottom";
import Buttons from "./components/Buttons/UniCellButtons";
import Left from "./components/Left/UniCellLeft";
import Middle from "./components/Middle/UniCellMiddle";
import Right from "./components/Right/UniCellRight";

export const UniCell = Object.assign(Component, {
    Left,
    Right,
    Bottom,
    Middle,
    Buttons,
});

export type { UniCellProps } from "./types";
